/**
 * @prettier
 */

import paperTypeSmooth from '../../../../assets/images/invitations/comparison-module/pdp_paperSmooth.jpg';
import paperTypeEggshell from '../../../../assets/images/invitations/comparison-module/pdp_paperEggshell.jpg';
import paperTypeRecycled from '../../../../assets/images/invitations/comparison-module/pdp_paperRecycled.jpg';
import paperTypePearlescent from '../../../../assets/images/invitations/comparison-module/pdp_paperPearlescent.jpg';
import paperTypeLinen from '../../../../assets/images/invitations/comparison-module/pdp_paperLinen.jpg';
import paperTypeNatural from '../../../../assets/images/invitations/comparison-module/pdp_paperNatural.jpg';
import paperTypeDoubleThick from '../../../../assets/images/invitations/comparison-module/pdp_paperDoubleThick.jpg';
import paperTypeTripleThick from '../../../../assets/images/invitations/comparison-module/pdp_paperTripleThick.jpg';

export default [
  {
    id: 'smooth',
    header: 'Smooth',
    description: 'A thin card stock with a clean, modern finish and a bit of sheen',
    imageSrc: paperTypeSmooth,
    feel: 'A lightweight business card with a smooth surface',
    ideal: 'Simple, sleek designs with large photos',
    why: 'That sheen makes photos, graphics, and text sing',
  },
  {
    id: 'eggshell',
    header: 'Eggshell',
    description: 'A thin card stock with a slight textured feel and matte finish',
    imageSrc: paperTypeEggshell,
    feel: 'Soft construction paper, but slightly thicker',
    ideal: 'Designs with watercolor and painterly details',
    why: 'Adds dimension, plus colors look richer',
  },
  {
    id: 'recycled',
    header: 'Recycled',
    description: 'A thick carbon-neutral paper with subtle but visible texture ',
    imageSrc: paperTypeRecycled,
    feel: 'A sturdy postcard with a soft, smooth surface',
    ideal: 'Botanical designs and rustic, natural wedding styles',
    why: 'Soft and 100% made of post-consumer waste',
  },
  {
    id: 'pearlized',
    header: 'Pearlescent',
    description: 'An iridescent paper with a subtle shimmer finish on both sides',
    imageSrc: paperTypePearlescent,
    feel: 'A glossy postcard with a slight metallic sheen',
    ideal: 'Glamorous designs and wedding styles',
    why: "It's chic with juuuust the right touch of shimmer",
  },
  {
    id: 'linen',
    header: 'Linen',
    description: 'A lightweight paper with a distinct crosshatch texture',
    imageSrc: paperTypeLinen,
    feel: 'A flexible postcard that mimics the look of linen fabric',
    ideal: 'Intricate designs with illustrations and florals',
    why: 'Great for classic and vintage styles alike',
  },
  {
    id: 'felt',
    header: 'Natural',
    description: 'A thick paper with a highly-textured look and feel',
    imageSrc: paperTypeNatural,
    feel: 'A sturdy postcard with a rugged, leathery surface',
    ideal: 'Elegant watercolor and painterly designs',
    why: 'It feels just as good as it looks',
  },
  {
    id: 'double-thick',
    header: 'Double Thick',
    description: 'A thick card stock with a smooth texture',
    imageSrc: paperTypeDoubleThick,
    feel: 'Twice as thick as a credit card, with a slight bend',
    ideal: "Single cards that don't require an envelope",
    why: 'Extra durable, surprisingly lightweight',
  },
  {
    id: 'triple-thick',
    header: 'Triple Thick',
    description: 'An extra-thick card stock with a smooth texture',
    imageSrc: paperTypeTripleThick,
    feel: "A hard notebook cover that's nearly unbendable",
    ideal: 'Bold cards you can cherish forever',
    why: 'So luxurious, it leaves a lasting impression',
  },
];
